export const MAXIMUM_IONIC_COL_SIZE = 12;
export const SLIDING_SIDE_END = 'end';
export const SLIDING_SIDE_START = 'start';